module.exports = __webpack_public_path__ + "static/img/loading.5f57288.gif";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/loading.gif
// module id = v+cv
// module chunks = 1